export default __webpack_public_path__ + "static/OSJRTMOONSHINECLUBFOAMTRUCKERHAT-BLACK_600x600-9025d85df802da3395dc2ebac1559e96.png";